import React from 'react';
import { useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import ContentColumn from '@starbucks-web/pattern-library/lib/components/content-column';
import Heading from '@starbucks-web/pattern-library/lib/components/heading';
import ExternalLink from 'shared/app/components/external-link';
import { commonMessages } from 'shared/app/messages/common-words';

import { rewardsQuestionsUrlSelector } from '../../../state/selectors';
import messages from '../messages';
import styles from './styles.cssm';

const FAQs = () => {
  const rewardsQuestionsUrl = useSelector(rewardsQuestionsUrlSelector);

  return (
    <ContentColumn className="sb-global-gutters--maxWidthLayout" size="xl">
      <div className="flex flex-column text-center items-center py5 md-py9">
        <Heading
          className="text-bold text-xl pb2 md-pb3 color-greenOnPrimary"
          tagName="h2"
        >
          <FormattedMessage {...commonMessages.questions} />
        </Heading>
        <p
          className={`${styles.bodyText} color-textBodyOnPrimary text-xs md-px9 md-mx4`}
        >
          <FormattedMessage
            {...messages.questionsBody}
            values={{
              link: (content) => (
                <ExternalLink
                  className="text-semibold"
                  href={rewardsQuestionsUrl}
                >
                  {content}
                </ExternalLink>
              ),
            }}
          />
        </p>
      </div>
    </ContentColumn>
  );
};

export default FAQs;
